module.exports = {"220303001":"平东街道","220303002":"北市场街道","220303003":"七马路街道","220303004":"四马路街道","220303005":"解放街道","220303006":"北门街道","220303007":"黄土坑街道","220303008":"平南街道","220303100":"山门镇","220303101":"石岭镇","220303102":"叶赫满族镇","220303170":"四平经济开发区（省级）（特殊乡镇）","220303200":"城东乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220303.json
// module id = 575
// module chunks = 0